import { Component, OnInit } from '@angular/core';
import { DashboardContractResumeData } from '@classes/dashboard-contract-resume-data';
import { Role } from '@enums/role.enum';
import { AccountService } from 'app/core/services/account.service';
import { DashboardService } from 'app/core/services/dashboard.service';

@Component({
  selector: 'app-contract-chart',
  templateUrl: './contract-chart.component.html',
  styleUrls: ['./contract-chart.component.scss']
})
export class ContractChartComponent implements OnInit {

  value = 50;

  contracts: Array<DashboardContractResumeData> = [];
  private userRole: Role | null;

  constructor(
    private dashboardService: DashboardService,
    public accountService: AccountService
  ) { }


  ngOnInit() {
    this.userRole = this.accountService.currentUser.value?.role_ || null;
    this.accountService.currentUser.subscribe(user => {
      this.userRole = user?.role_ != null ? user?.role_ : null;
      if (this.userRole == Role.user) {
        this.dashboardService.getDashboardContractResume().subscribe(data => {
          this.contracts = data.sort((a, b) => b.percentage > a.percentage ? 1 : ((a.percentage > b.percentage) ? -1 : 0));
        });
      }
    })
  }

}
